
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 440 440","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M341 50c8.284 0 15 6.716 15 15v310c0 8.284-6.716 15-15 15H99c-8.284 0-15-6.716-15-15V65c0-8.18 6.547-14.83 14.686-15H341zm0 10H99l-.217.005A5 5 0 0094 65v310a5 5 0 005 5h242a5 5 0 005-5V65a5 5 0 00-5-5zM153 223c8.284 0 15 6.716 15 15v20c0 8.284-6.716 15-15 15h-20c-8.284 0-15-6.716-15-15v-20c0-8.18 6.547-14.83 14.686-14.997L133 223h20zm150 33.5a5 5 0 01.217 9.995l-.217.005H197a5 5 0 01-.217-9.995l.217-.005h106zM153 233h-20l-.217.005A5 5 0 00128 238v20a5 5 0 005 5h20a5 5 0 005-5v-20a5 5 0 00-5-5zm97-2.5a5 5 0 01.217 9.995l-.217.005h-53a5 5 0 01-.217-9.995l.217-.005h53zM153 153c8.284 0 15 6.716 15 15v20c0 8.284-6.716 15-15 15h-20c-8.284 0-15-6.716-15-15v-20c0-8.18 6.547-14.83 14.686-14.997L133 153h20zm150 33.5a5 5 0 01.217 9.995l-.217.005H197a5 5 0 01-.217-9.995l.217-.005h106zM153 163h-20l-.217.005A5 5 0 00128 168v20a5 5 0 005 5h20a5 5 0 005-5v-20a5 5 0 00-5-5zm97-2.5a5 5 0 01.217 9.995l-.217.005h-53a5 5 0 01-.217-9.995l.217-.005h53zM133 85h20a5 5 0 01.217 9.995L153 95h-20a5 5 0 00-4.995 4.783L128 100v20a5 5 0 004.783 4.995L133 125h20a5 5 0 004.995-4.783L158 120v-1.045a5 5 0 019.995-.217l.005.217V120c0 8.18-6.547 14.83-14.686 14.997L153 135h-20c-8.18 0-14.83-6.547-14.997-14.686L118 120v-20c0-8.18 6.547-14.83 14.686-14.997L133 85h20zm170 33.5a5 5 0 01.217 9.995l-.217.005H197a5 5 0 01-.217-9.995l.217-.005h106zM171.328 84.106a5 5 0 017.344 6.788l-25.05 27.101a5 5 0 01-6.98.355l-9.934-8.768a5 5 0 016.617-7.498l6.27 5.535zM250 92.5a5 5 0 01.217 9.995l-.217.005h-53a5 5 0 01-.217-9.995L197 92.5h53z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    